import React, { useEffect, useState } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  getAllCoins,
  getCoinGeneralSettings,
  getDashboardGeneralSettings,
  updateCoinGeneralSettings,
  updateDashboardGeneralSettings,
} from "../../../api/coin";

const DashboardSettings = () => {
  const [allCoins, setAllCoins] = useState([]);
  const [selectedCoins, setSelectedCoins] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchAllCoins = async () => {
    setLoading(true);
    try {
      const res = await getAllCoins(1, 1000);
      setAllCoins(
        res?.data?.map((coin) => ({
          value: coin?.id.toLowerCase(),
          label: `${coin.name} (${coin.symbol})`,
        })) || []
      );
    } catch (err) {
      console.error("Failed to fetch coins", err);
      Swal.fire("Error", "Failed to load coin list.", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchSelectedCoins = async () => {
    try {
      const res = await getDashboardGeneralSettings();
      setSelectedCoins({
        row_one: res.row_one?.map((item) => item["id"]) || [],
        row_two: res.row_two?.map((item) => item["id"]) || [],
        row_three: res.row_three?.map((item) => item["id"]) || [],
      });
    } catch (err) {
      console.error("Failed to fetch selected coins", err);
      Swal.fire("Error", "Failed to load selected coins.", "error");
    }
  };

  useEffect(() => {
    fetchAllCoins();
    fetchSelectedCoins();
  }, []);

  const handleChange = (section, selectedOptions) => {
    console.log("selectedOptions", selectedOptions);
    setSelectedCoins((prev) => ({
      ...prev,
      [section]: selectedOptions.map((opt) => opt.value),
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateDashboardGeneralSettings({
        row_one: selectedCoins.row_one,
        row_two: selectedCoins.row_two,
        row_three: selectedCoins.row_three,
      });
      Swal.fire("Success", "Selections saved successfully!", "success");
    } catch (err) {
      console.error("Error saving selections", err);
      Swal.fire("Error", "Error saving selections", "error");
    } finally {
      setSaving(false);
    }
  };

  const getDefaultValues = (section) => {
    const selected = selectedCoins[section] || [];
    console.log("selected", selected);
    return allCoins.filter((coin) => selected?.includes(coin.value));
  };

  return (
    <div className="container-fluid mt-4">
      <h3 className="card-title">Admin Dashboard Settings</h3>
      {loading ? (
        <p>Loading coins...</p>
      ) : (
        <>
          {[
            { key: "row_one", label: "Row One", max: 4 },
            { key: "row_two", label: "Row Two", max: 4 },
            { key: "row_three", label: "Row Three", max: 2 },
          ].map(({ key, label, max }) => (
            <div key={key} className="mb-4">
              <label className="form-label fw-bold">{label}</label>
              <Select
                isMulti
                options={allCoins}
                value={getDefaultValues(key)}
                onChange={(options) => {
                  if (!options || options.length <= max) {
                    handleChange(key, options);
                  }
                }}
              />
            </div>
          ))}

          <button
            className="btn btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save Selections"}
          </button>
        </>
      )}
    </div>
  );
};

export default DashboardSettings;
